<template>
    <Content :error="error" :loading="loading" :length="engineers.length">
        <Card v-for="(engineer) in engineers" :key="engineer.id" :closable="true">
            <Engineer :engineer="engineer"></Engineer>
        </Card>
    </Content>
</template>

<script>
  import Engineer from '../cards/Engineer'
  import Card from '../shared/Card'
  import Content from '../shared/Content'

  export default {
    name: 'Engineers',

    components: {
      Card,
      Engineer,
      Content
    },

    props: {
      engineers: {
        default() { return [] },
        type: Array,
        required: true
      },

      loading: {
        type: Boolean,
        default: true
      },
    },

    computed: {
      error () {
        if (!this.loading && this.engineers.length < 1) {
          return {
            message: "Couldn't find Engineers to display",
            link: null
          }
        } else {
          return {
            message: null,
            link: null
          }
        }
      }
    }
  }
</script>
